import graphql__cc3f8e59d2ad2428d4a4 from "./__generated__/DeleteContactDialog_contact.graphql.ts";
import graphql__ab531a96132f30ce42f8 from "./__generated__/DeleteContactDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useNavigate} from "react-router-dom";
import Warning from "../presentational/Warning";
import {useIntl} from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type DeleteContactDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const DeleteContactDialog: React.FC<DeleteContactDialogProps> = (props) => {

    const navigate = useNavigate();
    const intl = useIntl();
    const contact = useFragment(
        graphql__cc3f8e59d2ad2428d4a4,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__ab531a96132f30ce42f8,
                variables: {
                    input: input
                },
                onCompleted: (_response: any, errors: string | any[]) => {
                    props.handleCloseDialog();
                    if (!errors || errors.length === 0) {
                        navigate('/contacts');
                    }
                },
                onError: (error: any) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToDeleteContact'})
            }
        )
    }

    const initialValues = {
        id: contact.id
    }

    const contactName = contact.teamName ?? (contact.givenName + ' ' + contact.familyName);

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    headline={intl.formatMessage({id: 'dialog.DeleteContactDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.DeleteContactDialog.submitLabel'})}
                    dangerous={true}>
            <Section>
                <Row>
                    <p className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.DeleteContactDialog.confirmMessage'}, {name: contactName})}
                    </p>
                </Row>
                <Row>
                    <Warning>
                        {intl.formatMessage({id: 'dialog.DeleteContactDialog.warning'})}
                    </Warning>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default DeleteContactDialog;
